import { useConfirmation } from "./useConfirmation";

export default useConfirmation;
